const breakpoints = {
  mobile: '@media (min-width: 600px)',
  tablet: '@media (min-width: 900px)',
  desktop: '@media (min-width: 1200px)',
  screen: '@media (min-width: 1536px)',

  mobileDown: '@media (max-width: 599px)',
  tabletDown: '@media (max-width: 899px)',
  desktopDown: '@media (max-width: 1199px)',
  screenDown: '@media (max-width: 1535px)',
};

export default breakpoints;
